import LazyLoadFailed from './LazyLoadFailed'

export default LazyLoadFailed
